import React from 'react'
import PropTypes from 'prop-types'
import { Root } from './Carousel.styles'

/**
 * The CarouselItem's component.
 */
const CarouselItem = props => {
  const { item } = props

  return <Root>{item}</Root>
}

CarouselItem.defaultProps = {
  item: null
}

CarouselItem.propTypes = {
  item: PropTypes.node
}

export default CarouselItem
